function map(value, inputMin, inputMax, outputMin, outputMax) {
  return (value - inputMin) * (outputMax - outputMin) / (inputMax - inputMin) + outputMin;
}
export {
  map as default
};
//# sourceMappingURL=map.js.map
